import React, { useState } from 'react';
import { Icon } from './icons';

const SportsFitImg = () => (
  <svg viewBox="0 0 375 120" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
    <circle cx="310" cy="-10" r="110" fill="rgba(16,185,129,0.09)" />
    <circle cx="50" cy="140" r="90" fill="rgba(193,255,114,0.07)" />
    <circle cx="188" cy="60" r="130" fill="rgba(16,185,129,0.04)" />
    <rect x="28" y="42" width="14" height="36" rx="4" fill="rgba(0,100,60,0.18)" />
    <rect x="16" y="48" width="14" height="24" rx="3" fill="rgba(0,100,60,0.14)" />
    <rect x="42" y="56" width="292" height="8" rx="4" fill="rgba(0,100,60,0.18)" />
    <rect x="334" y="42" width="14" height="36" rx="4" fill="rgba(0,100,60,0.18)" />
    <rect x="346" y="48" width="14" height="24" rx="3" fill="rgba(0,100,60,0.14)" />
    <rect x="165" y="52" width="46" height="16" rx="4" fill="rgba(0,100,60,0.26)" />
    <text x="22" y="104" fontFamily="Plus Jakarta Sans,sans-serif" fontSize="38" fontWeight="800" fill="rgba(0,100,60,0.08)" letterSpacing="-1">SPORT</text>
    <text x="22" y="112" fontFamily="Plus Jakarta Sans,sans-serif" fontSize="10" fontWeight="700" fill="rgba(0,100,60,0.25)" letterSpacing="0.14em">SPORTSFIT GYM</text>
  </svg>
);

const CafeMioImg = () => (
  <svg viewBox="0 0 375 120" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
    <circle cx="330" cy="0" r="100" fill="rgba(245,158,11,0.08)" />
    <circle cx="50" cy="140" r="80" fill="rgba(251,191,36,0.06)" />
    <path d="M148 28 Q144 78 160 94 Q188 102 216 94 Q232 78 228 28 Z" fill="rgba(180,120,15,0.14)" />
    <ellipse cx="188" cy="28" rx="40" ry="8" fill="rgba(180,120,15,0.18)" />
    <ellipse cx="188" cy="28" rx="33" ry="6" fill="rgba(245,158,11,0.22)" />
    <path d="M188 22 C176 14 176 32 188 34 C200 32 200 14 188 22" fill="rgba(160,100,10,0.18)" />
    <ellipse cx="188" cy="34" rx="8" ry="3" fill="rgba(160,100,10,0.12)" />
    <path d="M228 42 Q258 42 258 60 Q258 78 228 78" stroke="rgba(180,120,15,0.16)" strokeWidth="8" fill="none" strokeLinecap="round" />
    <ellipse cx="188" cy="96" rx="56" ry="9" fill="rgba(180,120,15,0.1)" />
    <path d="M174 18 Q170 8 174 0" stroke="rgba(180,120,15,0.15)" strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d="M188 14 Q184 4 188 -4" stroke="rgba(180,120,15,0.13)" strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d="M202 18 Q206 8 202 0" stroke="rgba(180,120,15,0.15)" strokeWidth="3" fill="none" strokeLinecap="round" />
    <ellipse cx="58" cy="36" rx="10" ry="15" transform="rotate(-35 58 36)" fill="rgba(160,100,10,0.1)" />
    <line x1="48" y1="27" x2="68" y2="45" stroke="rgba(160,100,10,0.06)" strokeWidth="2" />
    <ellipse cx="318" cy="82" rx="9" ry="13" transform="rotate(20 318 82)" fill="rgba(160,100,10,0.1)" />
    <text x="22" y="112" fontFamily="Plus Jakarta Sans,sans-serif" fontSize="10" fontWeight="700" fill="rgba(120,75,0,0.25)" letterSpacing="0.14em">CAFEMIO</text>
  </svg>
);

const RunwayBooksImg = () => (
  <svg viewBox="0 0 375 120" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
    <circle cx="310" cy="10" r="100" fill="rgba(139,92,246,0.07)" />
    <circle cx="50" cy="130" r="80" fill="rgba(167,139,250,0.05)" />
    <rect x="122" y="24" width="46" height="76" rx="3" fill="rgba(139,92,246,0.13)" />
    <rect x="122" y="24" width="7" height="76" rx="2" fill="rgba(139,92,246,0.2)" />
    <line x1="136" y1="36" x2="162" y2="36" stroke="rgba(139,92,246,0.1)" strokeWidth="2" />
    <line x1="136" y1="44" x2="162" y2="44" stroke="rgba(139,92,246,0.08)" strokeWidth="2" />
    <line x1="136" y1="52" x2="162" y2="52" stroke="rgba(139,92,246,0.08)" strokeWidth="2" />
    <line x1="136" y1="60" x2="162" y2="60" stroke="rgba(139,92,246,0.07)" strokeWidth="2" />
    <rect x="173" y="10" width="52" height="90" rx="3" fill="rgba(139,92,246,0.2)" />
    <rect x="173" y="10" width="8" height="90" rx="2" fill="rgba(139,92,246,0.3)" />
    <line x1="188" y1="24" x2="218" y2="24" stroke="rgba(255,255,255,0.18)" strokeWidth="2" />
    <line x1="188" y1="33" x2="218" y2="33" stroke="rgba(255,255,255,0.14)" strokeWidth="2" />
    <line x1="188" y1="42" x2="218" y2="42" stroke="rgba(255,255,255,0.14)" strokeWidth="2" />
    <line x1="188" y1="51" x2="212" y2="51" stroke="rgba(255,255,255,0.1)" strokeWidth="2" />
    <path d="M208 10 L208 38 L213 34 L218 38 L218 10 Z" fill="rgba(245,158,11,0.45)" />
    <rect x="230" y="20" width="42" height="80" rx="3" fill="rgba(139,92,246,0.11)" />
    <rect x="230" y="20" width="7" height="80" rx="2" fill="rgba(139,92,246,0.17)" />
    <line x1="244" y1="32" x2="266" y2="32" stroke="rgba(139,92,246,0.09)" strokeWidth="2" />
    <line x1="244" y1="40" x2="266" y2="40" stroke="rgba(139,92,246,0.08)" strokeWidth="2" />
    <line x1="244" y1="48" x2="266" y2="48" stroke="rgba(139,92,246,0.07)" strokeWidth="2" />
    <ellipse cx="199" cy="104" rx="75" ry="6" fill="rgba(0,0,0,0.05)" />
    <text x="22" y="112" fontFamily="Plus Jakarta Sans,sans-serif" fontSize="10" fontWeight="700" fill="rgba(80,40,160,0.22)" letterSpacing="0.14em">RUNWAY BOOKS</text>
  </svg>
);

const StatusBar = ({ light }) => (
  <div style={{ height: 44, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 24px 0', flexShrink: 0, position: 'relative', zIndex: 99 }}>
    <span style={{ fontSize: 15, fontWeight: 700, color: light ? 'white' : '#0f172a' }}>9:41</span>
    <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
      <Icon name="signal" size={14} color={light ? 'white' : '#0f172a'} />
      <Icon name="wifi" size={14} color={light ? 'white' : '#0f172a'} />
      <Icon name="battery" size={16} color={light ? 'white' : '#0f172a'} />
    </div>
  </div>
);

const BottomNav = ({ active, onNav }) => {
  const tabs = [
    { id: 'offers', label: 'Offers', icon: 'gift' },
    { id: 'benefits', label: 'Benefits', icon: 'shield' },
    { id: 'qr', label: 'QR Code', icon: 'qr' },
    { id: 'profile', label: 'Profile', icon: 'user' },
  ];
  return (
    <div style={{ position: 'absolute', bottom: 16, left: '50%', transform: 'translateX(-50%)', width: 330, height: 62, background: 'rgba(255,255,255,0.96)', backdropFilter: 'blur(12px)', borderRadius: 20, border: '1px solid rgba(255,255,255,0.6)', boxShadow: '0 4px 20px rgba(0,0,0,.14)', display: 'flex', zIndex: 50, padding: '0 8px' }}>
      {tabs.map(t => (
        <div key={t.id} onClick={() => onNav && onNav(t.id)} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, cursor: 'pointer', borderRadius: 14, color: active === t.id ? '#00bf63' : '#94a3b8', transition: 'color 0.15s' }}>
          <Icon name={t.icon} size={22} />
          <span style={{ fontSize: 10, fontWeight: 600, lineHeight: 1 }}>{t.label}</span>
        </div>
      ))}
    </div>
  );
};

export const OffersScreen = () => {
  const offers = [
    { vendor: 'SportsFit', title: '25% off gym membership', badge: 'NEW', discount: 25, bg: 'linear-gradient(135deg,#dcfce7,#a7f3d0)', Img: SportsFitImg, expiry: '3 weeks left' },
    { vendor: 'CafeMio', title: 'Free coffee with any lunch', badge: 'ENHANCED', bg: 'linear-gradient(135deg,#fef3c7,#fde68a)', Img: CafeMioImg, expiry: '5 days left' },
    { vendor: 'Runway Books', title: '30% off all purchases', badge: 'NEW', discount: 30, bg: 'linear-gradient(135deg,#ede9fe,#ddd6fe)', Img: RunwayBooksImg, expiry: '2 weeks left' },
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#f8fafc' }}>
      <div style={{ background: 'white', padding: '48px 20px 16px', borderBottom: '1px solid #f1f5f9', flexShrink: 0 }}>
        <StatusBar />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
          <div>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 2 }}>Good morning</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>Sarah Johnson</div>
          </div>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(135deg,#00bf63,#c1ff72)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, color: 'white' }}>SJ</div>
        </div>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#d1fae5', color: '#10b981', fontSize: 12, fontWeight: 600, padding: '4px 10px', borderRadius: 9999, marginTop: 8 }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#10b981' }} />
          Tier 1 · All Staff
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 16px 90px' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Your Offers
          <span style={{ fontSize: 13, color: '#00bf63', fontWeight: 600 }}>See all</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {offers.map((o, i) => (
            <div key={i} style={{ background: 'white', borderRadius: 16, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
              <div style={{ height: 120, background: o.bg, position: 'relative', overflow: 'hidden' }}>
                <o.Img />
                <div style={{ position: 'absolute', top: 8, right: 8, background: o.badge === 'NEW' ? '#00bf63' : '#f59e0b', color: 'white', fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 9999, zIndex: 2 }}>{o.badge}</div>
                {o.discount && (
                  <div style={{ position: 'absolute', bottom: 8, right: 8, background: 'linear-gradient(135deg,#ef4444,#dc2626)', color: 'white', width: 44, height: 44, borderRadius: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '2px solid rgba(255,255,255,0.4)', zIndex: 2 }}>
                    <span style={{ fontSize: 16, fontWeight: 800, lineHeight: 1 }}>{o.discount}</span>
                    <span style={{ fontSize: 9, fontWeight: 600 }}>%</span>
                  </div>
                )}
              </div>
              <div style={{ padding: '12px 14px 14px' }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>{o.vendor}</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a', marginBottom: 10, lineHeight: 1.3 }}>{o.title}</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#64748b', background: '#f1f5f9', padding: '4px 10px', borderRadius: 9999 }}>
                    <Icon name="clock" size={12} />{o.expiry}
                  </div>
                  <button style={{ background: '#00bf63', color: 'white', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>View</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const BenefitsScreen = () => {
  const cats = [
    { icon: 'dumbbell', label: 'Fitness & Wellness', count: 8, bg: '#dcfce7', ic: '#10b981' },
    { icon: 'coffee', label: 'Food & Dining', count: 12, bg: '#fef3c7', ic: '#f59e0b' },
    { icon: 'shopping', label: 'Retail & Shopping', count: 6, bg: '#ede9fe', ic: '#8b5cf6' },
    { icon: 'film', label: 'Entertainment', count: 5, bg: '#fee2e2', ic: '#ef4444' },
    { icon: 'travel', label: 'Travel', count: 4, bg: '#dbeafe', ic: '#3b82f6' },
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#f8fafc' }}>
      <div style={{ background: 'white', padding: '48px 20px 16px', borderBottom: '1px solid #f1f5f9', flexShrink: 0 }}>
        <StatusBar />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
          <div>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 2 }}>Browse by category</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>Benefits</div>
          </div>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(135deg,#00bf63,#c1ff72)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, color: 'white' }}>SJ</div>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 90px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {cats.map((c, i) => (
            <div key={i} style={{ background: 'white', borderRadius: 12, padding: 16, border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ width: 44, height: 44, borderRadius: 8, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icon name={c.icon} size={22} color={c.ic} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#0f172a' }}>{c.label}</div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{c.count} offers available</div>
              </div>
              <Icon name="chevron" size={18} color="#cbd5e1" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const QRVisual = () => {
  const p = [
    [1, 1, 1, 1, 1, 1, 1, 0, 1, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 0, 1, 0],
    [1, 0, 1, 1, 1, 0, 1, 0, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 0, 1, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 1, 0],
    [1, 1, 1, 1, 1, 1, 1, 0, 1, 1],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [1, 0, 1, 0, 1, 1, 0, 1, 1, 0],
    [0, 1, 0, 1, 0, 0, 1, 0, 1, 1],
  ];
  return (
    <div style={{ width: 200, height: 200, background: '#0f172a', borderRadius: 8, display: 'grid', gridTemplateColumns: 'repeat(10,1fr)', gridTemplateRows: 'repeat(10,1fr)', gap: 2, padding: 12 }}>
      {p.flat().map((c, i) => (
        <div key={i} style={{ background: c ? 'transparent' : 'white', borderRadius: 1 }} />
      ))}
    </div>
  );
};

export const QRScreen = () => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={{ background: '#0a1628', flexShrink: 0 }}>
      <StatusBar light />
      <div style={{ padding: '12px 20px 20px', color: 'white' }}>
        <div style={{ fontSize: 20, fontWeight: 800 }}>My QR Code</div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginTop: 4 }}>Show at checkout to redeem your perk</div>
      </div>
    </div>
    <div style={{ flex: 1, background: '#f8fafc', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, gap: 20 }}>
      <div style={{ background: 'white', borderRadius: 20, padding: 20, boxShadow: '0 12px 32px rgba(0,0,0,0.12)', border: '1px solid #e2e8f0' }}>
        <QRVisual />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>Sarah Johnson</div>
        <div style={{ fontSize: 13, color: '#64748b', marginTop: 3 }}>Acme Corp · Employee</div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#d1fae5', color: '#10b981', fontSize: 12, fontWeight: 600, padding: '5px 14px', borderRadius: 9999 }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#10b981' }} />
            Tier 1 · All Staff
          </div>
        </div>
      </div>
      <div style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', maxWidth: 220 }}>
        This QR code is unique to you. Do not share it with others.
      </div>
    </div>
  </div>
);

export const HeroPhone = () => {
  const [screen, setScreen] = useState('offers');
  const screens = {
    offers: <OffersScreen />,
    benefits: <BenefitsScreen />,
    qr: <QRScreen />,
  };
  return (
    <div className="phone-outer">
      <div className="phone-glow" />
      <div className="phone-shell">
        <div className="phone-notch" />
        <div className="phone-content-wrap">
          <div className="phone-content-inner">
            {screens[screen]}
            <BottomNav active={screen} onNav={setScreen} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const ScreenPhone = ({ children }) => (
  <div className="screen-phone">
    <div className="screen-notch" />
    <div className="screen-content-wrap">
      <div className="screen-content-inner">{children}</div>
    </div>
  </div>
);
